import { render, staticRenderFns } from "./Assembly.vue?vue&type=template&id=08627e6a&scoped=true"
import script from "./Assembly.vue?vue&type=script&lang=js"
export * from "./Assembly.vue?vue&type=script&lang=js"
import style0 from "./Assembly.vue?vue&type=style&index=0&id=08627e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08627e6a",
  null
  
)

export default component.exports